module.exports = __webpack_public_path__ + "static/media/metamask-icon.02e3ec27.png";